import { render, staticRenderFns } from "./UserAddModal.vue?vue&type=template&id=8b915316&scoped=true&"
import script from "./UserAddModal.vue?vue&type=script&lang=js&"
export * from "./UserAddModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b915316",
  null
  
)

export default component.exports